// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import ShoppingBag20 from './ShoppingBag20';
import ShoppingBag24 from './ShoppingBag24';

type ShoppingBagProps = {
    variation: '20' | '24';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    ShoppingBag20,
    ShoppingBag24,
};

const ShoppingBag: FC<ShoppingBagProps> = ({ variation, ...props }) => {
    const variationKey = `ShoppingBag${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"ShoppingBag" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default ShoppingBag;
